import React from "react";
import Search from "../users/Search";
import Users from "../users/Users";

function Home() {
  return (
    <>
      <Search />
      <Users />
    </>
  );
}

export default Home;
